export default __webpack_public_path__ + "static/live-hero-three-right-811a1a158c944fedb6884427923bc8f6.webp";